import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
   
  selector: '[siatStepContent]',
})
export class StepContentDirective {
  template = inject(TemplateRef);
}
